module.exports = __webpack_public_path__ + "static/media/RegenAg101CertificateOfCompletion.4489361e.png";